import React, { useState } from 'react'
import { Input, Button } from '../'

const val = (e) => (e.target !== undefined ? e.target.value : e.value)

// The popup opened by AppLinks' ✎ button. Mirrors LinkList's editor: owns a local copy of
// the links seeded at open time, and updates it on every add/remove. The parent persists
// the whole array on each change (see AppLinks.save), so onAdd must resolve with the created
// link and onRemove returns a promise — this component never re-reads the parent's state.
export const AppLinksEditor = ({ initialLinks, onAdd, onRemove }) => {
  const [links, setLinks] = useState(initialLinks)
  const [newLink, setNewLink] = useState({ label: '', url: '' })

  const submitNew = () => {
    if (!newLink.url) return
    onAdd(newLink).then(created => setLinks(prev => [...prev, created]))
    setNewLink({ label: '', url: '' })
  }

  const remove = (link) => {
    onRemove(link).then(() => setLinks(prev => prev.filter(l => l !== link)))
  }

  return (
    <div className="LinkList LinkListEditor">
      {links.length === 0 &&
        <p className="empty-text">Inga länkar</p>
      }
      {links.map((link, i) => (
        <div className="link-list-row" key={(link.link_url || '') + i}>
          <span className="link-icon">🔗</span>
          <a href={link.link_url} target="_blank" rel="noreferrer" className="link">{link.link_label || link.link_url}</a>
          {link.link_label &&
            <span className="link-url-note">{link.link_url}</span>
          }
          <button className="button-icon" title="Ta bort" onClick={() => remove(link)}>✕</button>
        </div>
      ))}
      <div className="link-list-new-row">
        <Input name="label" placeholder="Etikett" value={newLink.label} onChange={e => setNewLink({ ...newLink, label: val(e) })} />
        <Input name="url" placeholder="URL" value={newLink.url} onChange={e => setNewLink({ ...newLink, url: val(e) })} />
        <Button value="+ Lägg till länk" onClick={submitNew} disabled={!newLink.url} />
      </div>
    </div>
  )
}
